export default __webpack_public_path__ + "static/media/ium-reception.91c9f562.jpg";